var React = require('react');

function FlowTriangleRightInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"-449","y":"-28","className":"st0","width":"30","height":"80","key":0}),React.createElement("path",{"className":"st1","d":"M-419,12l-30,39.8v-79.7L-419,12z","key":1})]);
}

FlowTriangleRightInline.defaultProps = {"width":"30","height":"80","viewBox":"-449 -28 30 80"};

module.exports = FlowTriangleRightInline;

FlowTriangleRightInline.default = FlowTriangleRightInline;
